import { FrustumCulling } from "../../d3/graphics/FrustumCulling";
import { Vector3 } from "../../maths/Vector3";
export class RenderCullUtil {
    static cullByCameraCullInfo(cameraCullInfo, list, count, opaqueList, transparent, context) {
        const boundFrustum = cameraCullInfo.boundFrustum;
        const cullMask = cameraCullInfo.cullingMask;
        const staticMask = cameraCullInfo.staticMask;
        let render;
        let canPass;
        for (let i = 0; i < count; i++) {
            render = list[i];
            canPass = ((1 << render.layer) & cullMask) != 0 && (render.renderbitFlag == 0);
            canPass = canPass && ((render.staticMask & staticMask) != 0);
            if (canPass) {
                if (!cameraCullInfo.useOcclusionCulling || render._needRender(boundFrustum)) {
                    render.distanceForSort = Vector3.distanceSquared(render.bounds._imp.getCenter(), cameraCullInfo.position);
                    render._renderUpdatePre(context);
                    let element;
                    const elements = render.renderelements;
                    for (let j = 0, len = elements.length; j < len; j++) {
                        element = elements[j];
                        if (element.materialRenderQueue > 2500)
                            transparent.addRenderElement(element);
                        else
                            opaqueList.addRenderElement(element);
                    }
                }
            }
        }
    }
    static cullDirectLightShadow(shadowCullInfo, list, count, opaqueList, context) {
        opaqueList.clear();
        for (let i = 0; i < count; i++) {
            const render = list[i];
            if (render.shadowCullPass()) {
                if (FrustumCulling.cullingRenderBounds(render.bounds, shadowCullInfo)) {
                    render.distanceForSort = Vector3.distanceSquared(render.bounds._imp.getCenter(), shadowCullInfo.position);
                    render._renderUpdatePre(context);
                    let element;
                    const elements = render.renderelements;
                    for (let j = 0, len = elements.length; j < len; j++) {
                        element = elements[j];
                        if (element.materialRenderQueue < 2500)
                            opaqueList.addRenderElement(element);
                    }
                }
            }
        }
    }
    static cullSpotShadow(cameraCullInfo, list, count, opaqueList, context) {
        opaqueList.clear();
        const boundFrustum = cameraCullInfo.boundFrustum;
        for (let i = 0; i < count; i++) {
            const render = list[i];
            render._renderUpdatePre(context);
            if (render.shadowCullPass()) {
                render.distanceForSort = Vector3.distanceSquared(render.bounds._imp.getCenter(), cameraCullInfo.position);
                if (render._needRender(boundFrustum)) {
                    let element;
                    const elements = render.renderelements;
                    for (let j = 0, len = elements.length; j < len; j++) {
                        element = elements[j];
                        if (element.materialRenderQueue < 2500)
                            opaqueList.addRenderElement(element);
                    }
                }
            }
        }
    }
}
